import { render, staticRenderFns } from "./OrderRefundInfo.vue?vue&type=template&id=130bd9d5&"
import script from "./OrderRefundInfo.vue?vue&type=script&lang=js&"
export * from "./OrderRefundInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderRefundInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports